module.exports = __webpack_public_path__ + "img/d650370.webp";